<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
    <h3 class="text-center text-primary">Asignar ID curso de Moodle a los modulos de este programa</h3>
    <p class="text-center"> <small> {{parsePrograma()}} </small> </p>

    <p> <small> {{parseCategPrograma()}} </small> </p>
    <button class="btn btn-link btn-sm" :disabled="!$store.state.asignarCategoriaMoodle" data-toggle="modal" data-target="#modal-categoria" @click="programaClick( xprograma )"> <span class="glyphicon glyphicon-edit"></span> Asignar Moodle Categoria a este programa.</button>
    <button v-show="sede_permitida" :disabled="$store.state.CARGO.id == 13 || $store.state.asignarPlataforma" class="btn btn-sm btn-link" title="Asignar plataforma moodle" data-toggle="modal" data-target="#plataformasig" @click="asignarPlataforma(xprograma)"> <span class="glyphicon glyphicon-wrench"></span> Asignar plataforma moodle </button>

    <Alertas ref="alertar" />
    <div class="table-responsive">
      <table class="table table-condensed table-striped">
        <thead>
          <tr>
            <th> <small>Nro</small> </th>
            <th> <small>Modulo</small> </th>
            <th> <small>Curso ID</small> </th>
            <th> <small>Opciones</small> </th>
          </tr>
        </thead>

        <tbody>
          <tr :key="ind" v-for="(m,ind) in programa_modulos">
            <td> <small>{{m.numero}}</small> </td>
            <td> <small>{{m.modulo.nombre}}</small> </td>
            <td> <small>{{m.course_id}}</small> </td>
            <td>
              <button class="btn btn-link btn-sm" :disabled="!xprograma.course_category_id || !$store.state.asignarCourseProgramaModulo" data-toggle="modal" data-target="#modal-cate-modulo" @click="moduloClick( m )" title="Asignar Categoria Moodle"> <span class="glyphicon glyphicon-floppy-saved"></span> </button>
              <button class="btn btn-link btn-sm" :disabled="!xprograma.course_category_id || !m.course_id" data-toggle="modal" data-target="#modal-modulo-inscritos" @click="moduloClick( m )" title="Ver Inscritos"> <span class="glyphicon glyphicon-eye-open"></span> </button>
              <button class="btn btn-link btn-sm" :disabled="!xprograma.course_category_id || !m.course_id" data-toggle="modal" data-target="#modal-modulo-inscribir" @click="moduloClick( m )" title="Matricular Estudiantes"> <span class="glyphicon glyphicon-education"></span> </button>
              <button class="btn btn-link btn-sm" :disabled="!xprograma.course_category_id || !m.course_id" data-toggle="modal" data-target="#modal-modulo-eliminar" @click="moduloClick( m )" title="Des Matricular Estudiantes"> <span class="glyphicon glyphicon-trash"></span> </button> 
            </td>
          </tr>
        </tbody> 
      </table>
    </div>

    <APlataformaAsig id="plataformasig" v-bind:obj="seleccionadop" v-on:exito="modalExito"/>
    <CategoriaMoodleProg id="modal-categoria" :modulo="modulosel" :programa="xprograma" v-on:exito="setcateprograma"/>
    <ACategoriaMoodleModulo id="modal-cate-modulo" :modulo="modulosel" :xprograma="xprograma"/>
    <ACategoriaMoodleInscribir id="modal-modulo-inscribir" :modulo="modulosel" :xprograma="xprograma"/>
    <ACategoriaMoodleEliminar id="modal-modulo-eliminar" :modulo="modulosel" :xprograma="xprograma"/>
    <ACategoriaMoodleInscritos id="xxmodal-modulo-inscritos" :modulo="modulosel" :xprograma="xprograma"/>
    <notifications group="auth" position="bottom right" />
    <notifications group="auth4" position="bottom right" />
  </div>
</template>

<script>
import gql from 'graphql-tag';
import Alertas from '@/components/AAlertas.vue'
import APlataformaAsig from '@/components/APlataformaAsig.vue'
import CategoriaMoodleProg from '@/components/ACategoriaMoodlePrograma.vue'
import ACategoriaMoodleModulo from '@/components/ACategoriaMoodleModulo.vue'
import ACategoriaMoodleInscribir from '@/components/ACategoriaMoodleInscribir.vue'
import ACategoriaMoodleEliminar from '@/components/ACategoriaMoodleEliminar.vue'
import ACategoriaMoodleInscritos from '@/components/ACategoriaMoodleInscritos.vue'

export default {
  data(){
    return{
      seleccionadop: {xid:-1,xtitle:'X',xbody:'X',xsql:null,prog:{}},
      modulosel:{ pid:null,ccid:null,tag:null },
      xprograma:{course_category_id:null},
      programa_modulos: [],
      sede_permitida: false,
    }
  },
  components:{ APlataformaAsig,Alertas,CategoriaMoodleProg,ACategoriaMoodleModulo,ACategoriaMoodleInscribir,ACategoriaMoodleEliminar,ACategoriaMoodleInscritos },
  watch:{
    'xprograma.course_category_id': function(){
    }
  },
  methods:{
    modalExito(){},
    parsePrograma(){
      var post = "";
      if( this.xprograma.postgrado != null  ) post = this.xprograma.postgrado.nombre;
      return post+" version:"+this.xprograma.version+", grupo:"+this.xprograma.grupo+", gestion:"+this.xprograma.gestion;
    },
    isSedePermitida( sede_actual ){
      var sed = this.$store.state.CARGOS.find( x => x.idsede == sede_actual );
      this.sede_permitida = sed != null;
    },
    parseCategPrograma(){
      if( this.xprograma.course_category_id ) return "Este programa tiene el ID CATEGORIA: "+this.xprograma.course_category_id;
      else return "";
    },
    moduloClick( m ){
      this.modulosel.pid = m.idmodulo;
      this.modulosel.idcurso = m.course_id;
      this.modulosel.tag = m;
    },
    programaClick( p ){
      this.modulosel.pid = p.id;
      this.modulosel.tag = p;
    },
    setcateprograma( course_category_id ){
      this.xprograma.course_category_id = course_category_id;
      this.xprograma.postgrado.nombre += ".";
      // window.console.log( "EVENTO: ",window.stringifyObject(this.xprograma) );
    },
    asignarPlataforma( pro ){
      this.seleccionadop.xid = pro.id;
      //window.console.log( pro )
    },
    getPrograma(){
      var vue = this;
      this.$refs.alertar.cargando();
      var sql = gql`query{ 
        getPrograma(id:${this.xprograma.id}){inscripciones{estudiante{id,num_doc,nombres,pri_apellido,seg_apellido,usuario_moodle,clave_moodle,fecha_reg,email,telefono1}},course_category_id,programa_modulos{id,idmodulo,iddocente,numero,inicio,fin,estado,course_id,docente{num_doc,nombres,pri_apellido},modulo{id,nombre,sigla,tipo,estado}}} 
        getSede(id:${this.xprograma.sede.id}){id,nombre,correos{tipo direccion}}
        }`;
      // window.console.log( sql )
      this.$apollo.query({
        query: sql,
      }).then((data) => {
        var res = data.data.getPrograma;
        var sede = data.data.getSede;
        this.isSedePermitida( sede.id );
        this.$refs.alertar.reset();
        this.programa_modulos = res.programa_modulos;
        this.xprograma.course_category_id = res.course_category_id;
        this.xprograma.inscripciones = res.inscripciones;
        this.xprograma.sede = sede;

      }).catch((error) => {
        vue.$refs.alertar.invalido();
        this.activo = true;
        window.console.error(error);
        vue.msg = error;
      })
    },
  },
  mounted(){
    var xp = window.sessionStorage.xprograma;
    if( xp ) {
      var p = JSON.parse( xp );
      this.xprograma = p;
      delete this.xprograma.inscripciones;
      this.xprograma.course_category_id = 0;
      this.getPrograma();
      // window.console.log( "ID CURSOS::: ",this.xprograma )
    }
  }
}
</script>